export { Footer } from "@/components/layout/Footer";
